export interface IBaseSkuCharacteristicValue {
  valueId: string;
  disabled: boolean;
}

interface IBaseSkuCharacteristic {
  characteristicId: string;
  type: ESkuCharacteristicType;
  values: IBaseSkuCharacteristicValue[];
}

export interface ITextSkuCharacteristic extends IBaseSkuCharacteristic {
  type: ESkuCharacteristicType.TEXT;
  title: string;
  values: {
    valueId: string;
    text: string;
    disabled: boolean;
  }[];
}

interface IColorSkuCharacteristic extends IBaseSkuCharacteristic {
  type: ESkuCharacteristicType.COLOR;
  title: string;
  values: {
    mainColor: string;
    supportColor?: string;
    valueId: string;
    text: string;
    disabled: boolean;
  }[];
}

export interface IImageSkuCharacteristic extends IBaseSkuCharacteristic {
  type: ESkuCharacteristicType.IMAGE;
  title: string;
  values: {
    imageLink: string;
    valueId: string;
    photoKey: string;
    color: string;
    text: string;
    disabled: boolean;
  }[];
}

export type TSkuCharacteristic = ITextSkuCharacteristic | IColorSkuCharacteristic | IImageSkuCharacteristic;

export interface ISkuItemCharacteristic extends Omit<TSkuCharacteristic, 'values'> {
  value: TSkuCharacteristic['values'][number];
}

export enum ESkuCharacteristicType {
  TEXT = 'text',
  COLOR = 'color',
  IMAGE = 'image',
}

type TSkuCharacteristicValueId = TSkuCharacteristic['values'][number]['valueId'];
type TSkuCharacteristicId = TSkuCharacteristic['characteristicId'];

export type TSkuSelectedIds = Record<TSkuCharacteristicId, TSkuCharacteristicValueId>;
